/*

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
/* 
 * NOTE: As Backstage Entity AboutCard (backstage/plugins/catalog/src/components/AboutCard
/AboutCard.tsx) do not provide way to customize, this component copied from it and made necessary customization 
 */
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  makeStyles,
} from '@material-ui/core';
import {
  InfoCardVariants,
  Progress,
} from '@backstage/core-components';
import {
  useEntity,
} from '@backstage/plugin-catalog-react';

import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { AboutContent } from './AbbountContent/AboutContent';
import { InfraAboutContent } from './InfraAboutContent/InfraAboutContent';

const useStyles = makeStyles({
  gridItemCard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 10px)', // for pages without content header
    marginBottom: '10px',
  },
  fullHeightCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  gridItemCardContent: {
    flex: 1,
  },
  fullHeightCardContent: {
    flex: 1,
  },
});

/**
 * Props for {@link EntityAboutCard}.
 *
 * @public
 */
export interface AboutCardProps {
  variant?: InfoCardVariants;
}

const getCardClasses = (
  classes: ClassNameMap<
    | 'gridItemCard'
    | 'fullHeightCard'
    | 'gridItemCardContent'
    | 'fullHeightCardContent'
  >,
  isCard: boolean,
  variant?: string,
) => {
  if (variant === 'gridItem') {
    return isCard ? classes.gridItemCard : classes.gridItemCardContent;
  } else if (variant === 'fullHeight') {
    return isCard ? classes.fullHeightCard : classes.fullHeightCardContent;
  }
  return undefined;
};

/**
 * Exported publicly via the EntityAboutCard
 */
export function EntityAboutCard(props: AboutCardProps) {
  const { variant } = props;
  const classes = useStyles();
  const { entity } = useEntity();
  const isRefAppDownloading = false;
  
  return (
    <Card className={getCardClasses(classes, true, variant)}>
      {isRefAppDownloading && <Progress />}
      <CardHeader
        title="About"
        action={
          <>
            {/* {allowRefresh && canRefresh && (
              <IconButton
                aria-label="Refresh"
                title="Schedule entity refresh"
                onClick={refreshEntity}
              >
                <CachedIcon />
              </IconButton>
            )} */}
            {/* {!loadingPermission && (
              <IconButton
                component={Link}
                aria-label="Edit"
                disabled={!entityMetadataEditUrl || !canEditEntity}
                title="Edit Metadata"
                to={entityMetadataEditUrl ?? '#'}
              >
                <EditIcon />
              </IconButton>
            )} */}
          </>
        }
      />
      {/* <Box
        style={{ display: 'flex', flexDirection: 'row', padding: '0 16px 0' }}
      >
        <HeaderIconLinkRow links={entity.spec?.owner === 'bh-cordant-app-admin' ? infraSubHeaderLinks: subHeaderLinks} />
        <PostmanCollectionMenu entity={entity} />
        <ReferenceAppMenu
          entity={entity}
          onRefAppDownloading={handleRefAppDownload}
        />
      </Box> */}

      <Divider />
      <CardContent className={getCardClasses(classes, false, variant)}>
      { entity.spec?.owner === 'bh-cordant-app-admin' ? <InfraAboutContent entity={entity}/> : <AboutContent entity={entity}/>}
      </CardContent>
    </Card>
  );
}
